<template>
    <div class="linked-record-filter-button">
        <a-button @click="showRecordPicker" style="width: 100%">
            <template v-if="value">
                {{ getLinkedRecordLabel() }}
            </template>
            <template v-else>
                {{ $t("tables.selectRecord") }}
            </template>
        </a-button>

        <Modal2
            v-if="showModal"
            @cancel="closeModal"
            :title="$t('tables.selectRecord')"
            xlarge
            className="record-picker-modal keydown-prevent-modal"
        >
            <RecordPicker :table-id="getLinkedTableId" @record-selected="onRecordSelected" />
        </Modal2>
    </div>
</template>

<script>
import Vue from "vue";
import Modal2 from "@/components/common/Modal2.vue";
import RecordPicker from "../../pickers/RecordPicker.vue";
import { mapState } from "vuex";
export default Vue.extend({
    name: "LinkedRecordFilterButton",
    components: {
        Modal2,
        RecordPicker,
    },
    props: {
        value: {
            type: [String, Object],
            default: null,
        },
        field: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            showModal: false,
            lastSelectedRecord: null,
        };
    },
    computed: {
        ...mapState({
            tables: (state) => state.table.tables,
        }),
        getLinkedTableId() {
            return this.field.options.linkedRecord.table;
        },
    },
    methods: {
        showRecordPicker() {
            this.showModal = true;
        },
        closeModal() {
            this.showModal = false;
        },
        onRecordSelected(record) {
            this.lastSelectedRecord = record;
            this.$emit("input", record._id);
            this.closeModal();
        },
        getLinkedRecordLabel() {
            console.log(`getLinkedRecordLabel`, this.lastSelectedRecord);
            const record = this.lastSelectedRecord;
            if (!record) {
                if (typeof this.value === "object") {
                    return this.value._id;
                } else {
                    return this.value;
                }
            }

            const field = this.field;
            const linkedTable = this.tables.find((t) => t._id === field.options.linkedRecord.table);

            const identifierField = linkedTable.fields.find((f) => f.isIdentifierField);

            if (identifierField) {
                return record.data[identifierField._id];
            }

            return `Record ${record.recordId}`;
        },
    },
    watch: {
        showModal(isVisible) {
            if (isVisible) {
                const el = document.querySelector(".table-filter-popover");
                el.style.visibility = "hidden";
            } else {
                const el = document.querySelector(".table-filter-popover");
                el.style.visibility = "visible";
            }
        },
    },
});
</script>

<style scoped lang="scss">
.linked-record-filter-button {
    width: 100%;
}
</style>
